import { ScramjetClient } from "@client/index";
import { unrewriteUrl } from "@rewriters/url";
import { String, Object_freeze } from "@/shared/snapshot";

// Media session pictures (the artwork Chrome shows in its media controls) are fetched by the
// browser itself, outside the service worker: straight from the site, with the visitor's
// address (YouTube's video thumbnail, Twitch's channel picture). Their addresses are
// rewritten; reading them back gives the site's own.
export default function (client: ScramjetClient, self: Self) {
	if (!(self as any).MediaMetadata) return;

	const keep = (src: string) =>
		src.startsWith("data:") || src.startsWith("blob:");
	const rewriteArtwork = (artwork: any) => {
		if (!artwork || typeof artwork[Symbol.iterator] !== "function") return artwork;
		const out: any[] = [];
		for (const image of artwork) {
			if (image && typeof image === "object" && image.src != null) {
				const src = String(image.src);
				out.push({ ...image, src: keep(src) ? src : client.rewriteUrl(src) });
			} else {
				out.push(image);
			}
		}

		return out;
	};

	client.Proxy("MediaMetadata", {
		construct(ctx) {
			const init = ctx.args[0];
			if (init && typeof init === "object" && "artwork" in init) {
				ctx.args[0] = { ...init, artwork: rewriteArtwork(init.artwork) };
			}
		},
	});

	client.Trap("MediaMetadata.prototype.artwork", {
		get(ctx) {
			const list = ctx.get() as any[];
			if (!list) return list;

			return Object_freeze(
				list.map((image) => ({
					...image,
					src: keep(image.src) ? image.src : unrewriteUrl(image.src, client.context),
				}))
			);
		},
		set(ctx, value) {
			ctx.set(rewriteArtwork(value));
		},
	});
}
